module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-128.30f580a3.svg";